import { BaseService } from './base.service';
import { InspectionsProgramSimpleDto } from '../types/dtos/inspection';

/**
 * ChallengeProgramService handles CRUD operations for inspection programs.
 *
 * URL Pattern: /api/v1/inspections/{challengeId}/programs
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * @deprecated organizationId is deprecated and no longer used.
 */

const BASE_PATH = '/api/v1/inspections';

export class ChallengeProgramService extends BaseService<InspectionsProgramSimpleDto> {
  /**
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param challengeId - The challenge/inspection ID
   */
  constructor(_organizationId: string, challengeId: string) {
    super(`${BASE_PATH}/${challengeId}/programs`);
  }
}

export const createChallengeProgramService = (organizationId: string, challengeId: string) => new ChallengeProgramService(organizationId, challengeId); 